import React from "react";
import "./MealsForms.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import MealsData from "../../Pages/CalorieCounter/Meals/MealsData";
import AddIcon from "@mui/icons-material/Add";

export default function MealsForms() {
  const mealsData = [
    { id: 1, title: "امروز", label: "today" },
    { id: 2, title: "روز قبل", label: "yesterday" },
    { id: 3, title: "2 روز قبل", label: "2daysAgo" },
  ];

  const openMealCalorieHandler = (id, label) => {
    console.log(id, label);
  };
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <h3 className="pageTitle horizontalBorder">
            {" "}
            وعده های غذایی
            <img
              src="/images/fork&Knife.png"
              alt="fork&Knife"
              className="nutritionHeaderIcon"
            />
          </h3>
          <div className="scroll mealsFormsDays">
            <p className="mealsFormsDaysTitle">
              لطفا وعده های غذایی 3 روز خود را وارد کنید
            </p>
            {mealsData.map((day) => (
              <div key={day.id} className="mealsFormsDay">
                <div className="mealsFormsDayTitle centeredFlex">
                  <span>{day.title}</span>
                </div>
                <div className="mealsFormDayOptions centeredFlex">
                  {MealsData.map((meal) => (
                    <div key={meal.id} className="meal centeredFlex">
                      <img
                        src={meal.img}
                        alt="meals icon"
                        className="mealImg"
                      />
                      <span className="mealName">
                        {meal.name.includes("میان وعده")
                          ? "میان وعده"
                          : meal.name}
                      </span>
                      <div
                        onClick={() =>
                          openMealCalorieHandler(meal.id, meal.label)
                        }
                        className="mealBtn centeredFlex"
                      >
                        <AddIcon className="mealAddIcon" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <button className="nextQuestion">ارسال</button>
          </div>
        </div>
      </div>
    </div>
  );
}
